// extracted by mini-css-extract-plugin
module.exports = {"table-container":"ReadyOrders_table-container__201XE","table":"ReadyOrders_table__1jG19"};